import { FolderContent } from '@/api/generatedApi';
import { isAsset } from '@/utils/assets';
import { memo } from 'react';
import { AssetContentCard } from './AssetContentCard';
import { FolderContentCard } from './FolderContentCard';

const ContentCardInner = ({
  content,
  onContextMenu,
}: {
  content: FolderContent;
  onContextMenu?: (event: React.MouseEvent) => void;
}) => {
  if (isAsset(content)) {
    return <AssetContentCard asset={content} onContextMenu={onContextMenu} />;
  }
  return <FolderContentCard folder={content} onContextMenu={onContextMenu} />;
};

export const ContentCard = memo(ContentCardInner);
